<template>
  <div class="sidebar-holder">
    <!-- Schedule Payment -->
    <div
      class="item-payment"
      :class="{
        'item-payment--disabled': !hasCoparent && !hasRecordKeepingCoparents,
      }"
      v-click-outside-schedule="closeOutsideSchedulePayment"
    >
      <span
        class="item-payment-button"
        @click="handleOpenShowSchedulePayment"
        :class="{'disabled': (!hasCoparent && !hasRecordKeepingCoparents) || isAppLocked}"
        :disabled="isAppLocked"
      >
        <img src="@/assets/images/schedule_payment_ico.png" alt="Dolar calendar icon">
        <span>{{ $lang.messages.schedule }} {{ $lang.messages.originalPaymentPart2 }}</span>
        <img src="@/assets/images/schedule_payment_arrow.png" alt="White arrow right">
      </span>

      <!-- Payment Dropdown -->
      <payments-dropdown :isSchedulePaymentOpenProp="isSchedulePaymentOpen"></payments-dropdown>

      <f-p-registration-progress-tooltip
        v-if="hasScheduledPayments !== null && !hasScheduledPaymentsGotIt && $route.name === 'Dashboard' && totalSteps > 1"
        :class="{
          'arrow-tooltip--before': hasScheduledPayments === 'current',
          'sidebar-tooltip' : true
        }"
        style="top: calc((100% - 100px) / 2); left: 100%;"
        :text="$lang.messages.registration_progress_schedule_payment"
      >
        <div class="fp-registration-progress-tooltip-button">
          <button @click="dashboardPaymentStepsRegistration">
            {{ $lang.messages.registration_progress_btn_got_it_1 }}
          </button>
        </div>
      </f-p-registration-progress-tooltip>
    </div>
    <section class="sidebar-menu">
      <ul
        class="sidebar-list"
        :class="{'active-history': isFromSidebar || IS_PAYABLE_FROM_GETTER}"
      >
        <!-- User Info on Mobile -->
        <li class="item" @click="userInfoSubitem">
          <div class="user-info">
            <div class="item">
            <span class="name">
              {{ shrinkFirstName }} {{ shrinkLastName }}
            </span>
              <span class="online-marker-wrapper">
              <div class="online-marker"></div>
            </span>
              <span class="arrow-wrapper" :class="{'rotate': isUserInfoSubitem}">
              <img class="icon" src='@/assets/images/arrow_down.png' :class="{'rotate-icon': isUserInfoSubitem}" />
              <img class="icon icon-hidden" src='@/assets/images/arrow_down_blue.png'  :class="{'rotate-icon': isUserInfoSubitem}" />
            </span>
            </div>
            <div class="submenu" :class="{'submenu-collapsed': isUserInfoSubitem}">
              <div class="type-two">
                <div>
                  <div class="online-marker"></div>
                  <p>{{ $lang.messages.online }}</p>
                  <img src='@/assets/images/checkmark_large.png' />
                </div>
              </div>
              <div class="type-two no-background">
                <div>
                  <div class="invisible-marker"></div>
                  <p>{{ $lang.messages.invisible }}</p>
                </div>
              </div>
              <div class="type-one" @click="toggleSidebar">
                <router-link :to="{ name: 'UserProfile' }">
                  {{ $lang.messages.userProfile }}
                </router-link>
              </div>
              <div class="type-one" @click="toggleSidebar">
                <router-link :to="{ name: 'FamilyProfile' }">
                  {{ $lang.messages.familyProfile }}
                </router-link>
              </div>
              <div class="type-one" :class="{'app--locked': childAdded === 'unfinished' || childAdded === 'current'}" @click="toggleSidebar">
                <router-link :to="{ name: 'PaymentMethods' }">
                  {{ $lang.messages.paymentMethods }}
                </router-link>
              </div>
              <div class="type-one logout-link" @click.prevent="logout">{{ $lang.messages.logout }}</div>
            </div>
          </div>
        </li>
        <!-- Dashboard -->
        <li
          class="item"
          @click="chooseItem"
          :class="{'disabled-link' : !hasCoparent && !hasRecordKeepingCoparents, 'app--locked': isAppLocked}"
        >
          <router-link :to="{ name: 'Dashboard' }" class="link">
          <span class="item-content">
            <div class="icon-wrapper">
              <img class="icon" src='@/assets/images/dashboard_ico_passive.png' />
              <img class="icon icon-hidden" src='@/assets/images/dashboard_ico_active.png' />
            </div>
            <div class="label">
              <span>{{ $lang.messages.dashboard }}</span>
            </div>
          </span>
          </router-link>
        </li>
        <!-- Payments -->
        <li
          class="item"
          @click="chooseItem"
          :class="{'disabled-link' : !hasCoparent && !hasRecordKeepingCoparents, 'app--locked': isAppLocked}"
        >
          <router-link
            :to="{ name: 'Payments' }"
            class="link"
            :class="{'active--sidebar--item': isFromSidebar || IS_PAYABLE_FROM_GETTER}"
          >
          <span class="item-content">
            <div class="icon-wrapper">
              <img class="icon" src='@/assets/images/payment_ico_passive.png' />
              <img class="icon icon-hidden" src='@/assets/images/payment_ico_active.png' />
            </div>
            <div class="label">
              <span>{{ $lang.messages.payments }}</span>
            </div>
          </span>
          </router-link>
        </li>
        <ul class="payments--dropdown">
          <!-- Unpaid -->
          <li
            class="item"
            @click="chooseItem"
            :class="{'disabled-link' : !hasCoparent && !hasRecordKeepingCoparents,'app--locked': isAppLocked}"
          >
            <router-link :to="{ name: 'Unpaid' }" class="link">
            <span class="item-content">
              <div class="icon-wrapper">
                <img class="icon" src='@/assets/images/unpaid_ico_passive.png' />
                <img class="icon icon-hidden" src='@/assets/images/unpaid_ico_active.png' />
              </div>
              <div class="label">
                <span>{{ $lang.messages.unpaid }}</span>
              </div>
            </span>
            </router-link>
          </li>
          <!-- Recurring -->
          <li
            class="item"
            @click="chooseItem"
            :class="{'disabled-link' : !hasCoparent && !hasRecordKeepingCoparents,'app--locked': isAppLocked}"
          >
            <router-link :to="{ name: 'Recurring' }" class="link">
            <span class="item-content">
              <div class="icon-wrapper">
                <img class="icon" src='@/assets/images/recurring_payments_ico_passive.png' />
                <img class="icon icon-hidden" src='@/assets/images/recurring_payments_ico_active.png' />
              </div>
              <div class="label">
                <span>{{ $lang.messages.recurring }}</span>
              </div>
            </span>
            </router-link>
          </li>
          <!-- Transaction History -->
          <li
            class="item"
            @click="chooseItem"
            :class="{'disabled-link' : !hasCoparent && !hasRecordKeepingCoparents, 'app--locked': isAppLocked}"
          >
            <router-link
              :to="{ name: 'History' }"
              class="link"
              :class="{'active--sidebar--item': isFromSidebar || IS_PAYABLE_FROM_GETTER}"
            >
            <span class="item-content">
              <div class="icon-wrapper">
                <img class="icon" src='@/assets/images/transaction_history_ico_passive.png' />
                <img class="icon icon-hidden" src='@/assets/images/transaction_history_ico_active.png' />
              </div>
              <div class="label">
                <span>{{ $lang.messages.transactionHistory }}</span>
              </div>
            </span>
            </router-link>
          </li>
        </ul>
        <!-- Calendar -->
        <li
          class="item"
          @click="chooseItem"
          :class="{'disabled-link' : !hasChildren, 'app--locked': isAppLocked}"
          ref="calendarSidebar"
        >
          <router-link :to="{ name: 'Calendar' }" class="link">
          <span class="item-content">
            <div class="icon-wrapper">
              <img class="icon" src='@/assets/images/schedule_ico_passive.png' />
              <img class="icon icon-hidden" src='@/assets/images/schedule_ico_active.png' />
              <!-- <div class="notification-marker"></div> -->
            </div>
            <div class="label">
              <span>{{ $lang.messages.calendar }}</span>
            </div>
          </span>
          </router-link>
        </li>
        <!-- Message Center -->
        <li
          class="item"
          @click="chooseItem"
          :class="{'disabled-link' : !hasCoparent, 'app--locked': isAppLocked}"
        >
          <router-link :to="{ name: 'MessageCenter' }" class="link">
          <span class="item-content">
            <div class="icon-wrapper">
              <img class="icon" src='@/assets/images/message_center_ico_passive.png' />
              <img class="icon icon-hidden" src='@/assets/images/message_center_ico_active.png' />
               <div class="notification-marker" v-if="checkUnreadMessages() >= 1"></div>
            </div>
            <div class="label">
              <span>{{ $lang.messages.messageCenter }}</span>
            </div>
          </span>
          </router-link>
        </li>
        <!-- Reports -->
        <li
          class="item"
          @click="chooseItem"
          :class="{'disabled-link' : !hasCoparent && !hasRecordKeepingCoparents, 'app--locked': isAppLocked}"
        >
          <router-link :to="{ name: 'Reports' }" class="link">
          <span class="item-content">
            <div class="icon-wrapper">
              <img class="icon" src='@/assets/images/reports_ico_passive.png' />
              <img class="icon icon-hidden" src='@/assets/images/reports_ico_active.png' />
            </div>
            <div class="label">
              <span>{{ $lang.messages.reportsHeadline }}</span>
            </div>
          </span>
          </router-link>
        </li>
        <!-- Document Cabinet -->
        <li class="item doc-cabinet-link">
        <span class="link">
          <span class="item-content">
            <div class="icon-wrapper">
              <img class="icon" src='@/assets/images/files_cabinet_ico_passive.png' />
              <!-- TODO: implement later-->
              <!--<img class="icon icon-hidden" src='@/assets/images/files_cabinet_ico_active.png' />-->
            </div>
            <div class="label">
              <span>{{ $lang.messages.docCabinetHeadline }}</span>
            </div>
          </span>
        </span>
          <div>
            <span>{{ $lang.messages.comingSoon }}</span>
          </div>
        </li>
        <!-- Change Theme -->
        <!--<li class="item" @click="changeTheme" >-->
        <!--  <div class="link">-->
        <!--    <span class="item-content">-->
        <!--      <div class="icon-wrapper">-->
        <!--        <img class="icon" src='@/assets/images/reports_ico_passive.png' />-->
        <!--        <img class="icon icon-hidden" src='@/assets/images/reports_ico_active.png' />-->
        <!--      </div>-->
        <!--      <div class="label">-->
        <!--        <span>Change Theme</span>-->
        <!--      </div>-->
        <!--    </span>-->
        <!--  </div>-->
        <!--</li>-->
      </ul>
      <!-- Sidebar footer -->
      <div class="sidebar-footer-wrapper">
        <div class="sidebar-footer-img"></div>
        <div class="sidebar-footer-links">
          <div class="item">
            <a href="https://familipay.com/faq/" target="_blank">
              <img src='@/assets/images/help_ico_passive.png' class="item-img" />
              <span class="item-label">{{ $lang.messages.faqSidebar }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" x="0px" y="0px" viewBox="0 0 100 100" width="15" height="15" class="icon-outbound">
                <path fill="currentColor" d="M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"></path>
                <polygon fill="currentColor" points="45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"></polygon>
              </svg>
            </a>
          </div>
          <div class="item">
            <a href="mailto:support@familipay.com">
              <img src='@/assets/images/support_ico_passive.png' class="item-img" />
              <span class="item-label">{{ $lang.messages.support }}</span>
            </a>
          </div>
        </div>
      </div>

    </section>
    <!-- FIXME: Due to overflow of '.sidebar-menu' we need to calculate the position of calendar item in Sidebar -->
    <f-p-registration-progress-tooltip
      v-if="!hasEventOrVisitationsGotIt && hasEventOrVisitations !== null && $route.name === 'Dashboard' && totalSteps > 1"
      :class="{
        'arrow-tooltip--before': hasEventOrVisitations === 'current',
        'sidebar-tooltip' : true
      }"
      :style="{top: `${calendarPositionTooltip}px`}"
      :text="$lang.messages.registration_progress_calendar"
    >
      <div class="fp-registration-progress-tooltip-button">
        <button @click="dashboardCalendarStepsRegistration">
          {{ $lang.messages.registration_progress_btn_got_it_1 }}
        </button>
      </div>
    </f-p-registration-progress-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  LOGOUT,
  GET_PAYABLE_FROM,
  GET_REGISTRATION_PROGRESS,
  SUBSCRIPTION_PAST_DUE_LOCK,
  REGISTRATION_PROGRESS_GOT_IT_TOOLTIPS
} from "@/store/action.types";
import PaymentsDropdown from './PaymentsDropdown';
import FPRegProgressTooltip from '@/components/common/FPRegistrationProgressTooltip';
import vClickOutside from 'v-click-outside';
import { API_ENV_NAME } from '@/common/config';

export default {
  name: "Sidebar",
  directives: {
    clickOutsideSchedule: vClickOutside.directive
  },
  components: {
    'payments-dropdown': PaymentsDropdown,
    'f-p-registration-progress-tooltip': FPRegProgressTooltip
  },
  props: {
    toggleSidebar: {
      type: Function
    },
    sidebarExpanded: {
      type: Boolean
    }
  },
  data() {
    return {
      isSchedulePaymentOpen: false,
      isSubmenuCollapsed: false,
      isUserSubmenuCollapsed: false,
      isUserInfoSubitem: false,
      isFromSidebar: false,
      conversationsList: [],
      calendarPositionTooltip: 0,
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "hasCoparent",
      "hasChildren",
      "hasRecordKeepingCoparents",
      "IS_PAYABLE_FROM_GETTER",
      "isAppLocked",
      "isSubscriptionPastDue",
      "hasScheduledPayments",
      "hasScheduledPaymentsGotIt",
      "hasEventOrVisitations",
      "hasEventOrVisitationsGotIt",
      "totalSteps",
      "childAdded"
    ]),
    shrinkFirstName() {
      if (this.user.firstname) {
        let firstnameTemp = this.user.firstname;
        if (firstnameTemp.length > 16) {
          firstnameTemp =  firstnameTemp.substr(0, 1) + '.'
        }
        return firstnameTemp
      }
      return ''
    },
    shrinkLastName() {
      if (this.user.lastname) {
        let lastnameTemp = this.user.lastname;
        if (lastnameTemp.length > 16) {
          lastnameTemp =lastnameTemp.substr(0, 1) + '.'
        }
        return lastnameTemp;
      }
      return ''
    }
  },
  watch: {
    $route(to, from) {
      // Reset sidebar to default, therefore close the aside menu
      // on tablet, high-tier mobile and above
      if (to.path !== from.path) {
        if (window.innerWidth >= 768 && window.innerWidth <= 1280 && this.sidebarExpanded) {
          this.collapseSubmenu();
          this.toggleSidebar();
        }
        this.isSchedulePaymentOpen = false;
      }
      // When navigating from payments/history or payments/recurring/details/:guid to payments-details
      // override the active-class on Sidebar and add active class
      // to history item
      if (
        from.name === 'History' &&
        (
          to.name === 'ExpenseDetailsSpousalMaintenance' ||
          to.name === 'ExpenseDetailsChildMaintenance' ||
          to.name === 'ExpenseDetailsSharedExpenses' ||
          to.name === 'SpousalMaintenanceRecurringExpensesDetails' ||
          to.name === 'ChildMaintenanceRecurringExpensesDetails' ||
          to.name === 'SharedExpensesRecurringExpensesDetails'
        )
      ) {
        this.isFromSidebar = true
      }
      // If we are sending parameters via payment status or user has clicked on "Already Paid" button
      else if (
        this.$route.params.expenseStatus === 'PAID' ||
        this.$route.params.expenseStatus === 'PAID_EXTERNALLY'
      ) {
        this.isFromSidebar = true
      }
      // Return sidebar active classes to default
      else {
        this.isFromSidebar = false
      }
    },
    // On hamburger menu clicked reset the Aside menu to default
    sidebarExpanded() {
      if (window.innerWidth < 900) {
        this.isSubmenuCollapsed = false;
        this.isUserInfoSubitem = false;
      }
    }
  },
  mounted() {
    this.conversationsList = this.$store.getters.getConversationsList;
    this.$root.$on('conversations', this.conversationsUpdated);
    this.positionOfCalendarItem();
    this.subscriptionPastDueAction(false)
  },
  methods: {
    ...mapActions({
      logoutAction: LOGOUT,
      GET_PAYABLE_FROM,
      getRegistrationProgressAction: GET_REGISTRATION_PROGRESS,
      subscriptionPastDueAction: SUBSCRIPTION_PAST_DUE_LOCK,
      registrationProgresssGotItTooltipsAction: REGISTRATION_PROGRESS_GOT_IT_TOOLTIPS
    }),
    // changeTheme() {
    //   if (localStorage.getItem('theme') === 'dark') {
    //       localStorage.setItem('theme', 'light');
    //       document.body.setAttribute('theme', 'light');
    //   }
    //   else {
    //       localStorage.setItem('theme', 'dark');
    //       document.body.setAttribute('theme', 'dark')
    //   }
    // },
    conversationsUpdated(conversations) {
      this.conversationsList = conversations;
      this.$forceUpdate();
    },
    // On mobile portrait open the User Info Sub menu
    userInfoSubitem() {
      this.collapseSubmenu();
      this.isUserInfoSubitem = !this.isUserInfoSubitem;
    },
    // On selected sidebar link
    chooseItem() {
      if (this.sidebarExpanded && window.innerWidth <= 1024) {
        this.isUserInfoSubitem = false;
        this.toggleSidebar();
        this.collapseSubmenu();
        // When user click on any sidebar item reset the breadcrumb and active classes to default
        this.$store.dispatch('GET_PAYABLE_FROM', false);
        return
      }
      this.collapseSubmenu();
      // When user click on any sidebar item reset the breadcrumb and active classes to default
      this.$store.dispatch('GET_PAYABLE_FROM', false);
    },
    // Handle Expense & Payments Sub menu to close
    collapseSubmenu() {
      this.isSubmenuCollapsed = false;
      this.isSchedulePaymentOpen = false;
    },
    logout() {
      this.logoutAction().then(() => {
        if (API_ENV_NAME === 'demo') {
          this.$router.push({ name: "Demo" });
        }
        this.$router.push({ name: "Login" });
      });
    },
    /**
     * @description Toggle show/hide the Schedule payment dropdown
     */
    handleOpenShowSchedulePayment () {
      this.isSchedulePaymentOpen = !this.isSchedulePaymentOpen;
    },
    // On outside click of Schedule payment close the dropdown
    closeOutsideSchedulePayment () {
      this.isSchedulePaymentOpen = false;
    },
    // Check are there any unread messages
    checkUnreadMessages() {
      return this.conversationsList.filter(elem => {
        return elem.unreadMessageCount
      }).length;
    },
    /**
     * @description When user clicks on "Got it" button on schedule payment
     * call API for updating the value
     */
    dashboardPaymentStepsRegistration() {
      const tooltipsList = [{uiId: 'SCHEDULE_PAYMENT', show: false}];
      this.registrationProgresssGotItTooltipsAction(
        {
          tooltips: tooltipsList,
        }
      )
      .then(response => {
        this.getRegistrationProgressAction();
      })
    },
    /**
     * @description When user clicks on "Got it" button on parenting calendar
     * call API for updating the value
     */
    dashboardCalendarStepsRegistration() {
      const tooltips = [{uiId: 'PARENTING_CALENDAR', show: false}];
      this.registrationProgresssGotItTooltipsAction(
        {
          tooltips: tooltips,
        }
      )
      .then(response => {
        this.getRegistrationProgressAction();
      })
    },
    positionOfCalendarItem() {
      let elem = this.$refs.calendarSidebar;
      this.calendarPositionTooltip = elem.getBoundingClientRect().top - 85;
    }
  }
};
</script>

